import type { UserRole } from '../types';

export function normalizeUserRole(role: unknown): UserRole {
  const raw = String(role ?? '').trim().toLowerCase();
  if (raw === 'admin') return 'admin';
  if (raw === 'teacher') return 'teacher';
  return 'student';
}

export function isAdminRole(role: unknown): boolean {
  return normalizeUserRole(role) === 'admin';
}

export function isTeacherRole(role: unknown): boolean {
  return normalizeUserRole(role) === 'teacher';
}

export function canAccessManagementArea(role: unknown): boolean {
  const normalized = normalizeUserRole(role);
  return normalized === 'admin' || normalized === 'teacher';
}

export function canAccessLearnerArea(role: unknown): boolean {
  return !isTeacherRole(role);
}

export function canAccessStudentManagement(role: unknown): boolean {
  return canAccessManagementArea(role);
}

export function canAccessQuestionManagement(role: unknown): boolean {
  return isAdminRole(role);
}

export function canAccessQuestionApproval(role: unknown): boolean {
  return isAdminRole(role);
}

export function canAccessMediaManagement(role: unknown): boolean {
  return isAdminRole(role);
}

export function canAccessVocabManagement(role: unknown): boolean {
  return isAdminRole(role);
}

export function getDefaultAuthenticatedRoute(role: unknown): '/' | '/admin' {
  return isTeacherRole(role) ? '/admin' : '/';
}
